import { memo, type MouseEvent as ReactMouseEvent } from 'react';
import { Center } from '~/commonComponents/Center';
import { Column } from '~/commonComponents/Column';
import { Value as FieldValue } from '~/commonComponents/InputJob/Field';
import { Row } from '~/commonComponents/Row';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { CloseIcon } from '~/images/icons';
import PlusIcon from '~/images/icons/PlusIcon';
import { IInputInviteCandidateValue } from './Types';

interface IValueProps {
  values?: IInputInviteCandidateValue[];
  onInviteMoreClick?(): void;
  onRemoveProfessional?(value: IInputInviteCandidateValue, index: number): void;
}

const Component = ({ values = [], onInviteMoreClick, onRemoveProfessional }: IValueProps) => {
  const hasValues = values.length > 0;

  const handleInviteMoreClick = (e: ReactMouseEvent) => {
    e.stopPropagation();
    onInviteMoreClick?.();
  };

  const handleRemoveProfessionalClick = (index: number) => (e: ReactMouseEvent) => {
    e.stopPropagation();
    onRemoveProfessional?.(values[index], index);
  };

  if (!hasValues) {
    return <FieldValue style={{ color: colors.neutral[300] }} text="Add Candidates" />;
  }

  return (
    <Column alignItems="flex-end" gap={15}>
      {values.map((it, i) => (
        <Row data-testid={`input-invite-candidate.item-${it.value}`} key={it.value}>
          <Typography
            as="span"
            data-testid={`input-invite-candidate.item-${it.value}.text`}
            style={{ textTransform: 'capitalize' }}
          >
            {it.label}
          </Typography>
          <Center
            data-testid={`input-invite-candidate.item-${it.value}.close-icon`}
            cursor="pointer"
            marginLeft={30}
            marginRight={-30}
            role="button"
            onClick={handleRemoveProfessionalClick(i)}
          >
            <CloseIcon color={colors.secondary[500]} />
          </Center>
        </Row>
      ))}

      <Row
        alignItems="center"
        cursor="pointer"
        data-testid={`input-invite-candidate.add-invite-more`}
        gap={8}
        role="button"
        onClick={handleInviteMoreClick}
      >
        <PlusIcon color={colors.secondary[500]} />
        <Typography as="span" bold color={colors.secondary[500]} size="body_large">
          Invite More
        </Typography>
      </Row>
    </Column>
  );
};

export const Value = memo(Component);
